export default "/_next/static/images/before-f6b1c3bbdec27937e815cde7835bf24e.png";